import { useEffect, useRef, useState } from 'react';

const categories = [
  {
    id: 1,
    title: 'კერამიკა',
    subtitle: 'Laminam',
    description: 'Laminam-ის ულტრა-თხელი დიდი ფორმატის კერამიკული ფილები კედლისა, იატაკისა და ფასადისთვის. 3მმ-დან 20მმ-მდე სისქით.',
    image: 'https://readdy.ai/api/search-image?query=Large%20format%20ceramic%20tiles%20display%20showroom%20elegant%20marble%20pattern%20tiles%20stacked%20on%20wall%20warm%20golden%20lighting%20luxury%20interior%20design%20photography&width=600&height=800&seq=phoenix-cat-1&orientation=portrait',
    count: '1,200+',
    icon: 'ri-layout-grid-line',
  },
  {
    id: 2,
    title: 'იატაკი',
    subtitle: 'Fodbo, Dicson',
    description: 'Fodbo და Dicson-ის ლამინირებული პარკეტი, ინჟინერული ხე, SPC და LVT ფილები. ნებისმიერი სტილისა და ფერის არჩევანი.',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20wood%20flooring%20display%20showroom%20warm%20oak%20parquet%20elegant%20interior%20warm%20golden%20lighting%20professional%20photography&width=600&height=800&seq=phoenix-cat-5&orientation=portrait',
    count: '600+',
    icon: 'ri-stack-line',
  },
  {
    id: 3,
    title: 'ფრიალი იატაკი',
    subtitle: 'Ardex, Tecnopol',
    description: 'Ardex და Tecnopol-ის თხევადი ეპოქსიდური და პოლიურეთანის ფრიალი იატაკის სისტემები კომერციული და საცხოვრებელი გამოყენებისთვის.',
    image: 'https://readdy.ai/api/search-image?query=Polished%20concrete%20epoxy%20floor%20coating%20display%20showroom%20industrial%20modern%20interior%20warm%20lighting%20professional%20photography&width=600&height=800&seq=phoenix-cat-3&orientation=portrait',
    count: '280+',
    icon: 'ri-water-flash-line',
  },
  {
    id: 4,
    title: 'ჭერი',
    subtitle: 'Armstrong, Knauf',
    description: 'გაჭიმული ჭერის სისტემები, ბაფლები, ბეტონის ეფექტი და აკუსტიკური პანელები ნებისმიერი ინტერიერისთვის.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20suspended%20ceiling%20systems%20display%20showroom%20acoustic%20panels%20elegant%20interior%20warm%20lighting%20professional%20photography&width=600&height=800&seq=phoenix-cat-4&orientation=portrait',
    count: '320+',
    icon: 'ri-home-4-line',
  },
  {
    id: 5,
    title: 'ფასადი',
    subtitle: 'Laminam, Tecnopol',
    description: 'Laminam და Tecnopol-ის გარე ფასადის სისტემები, ვენტილირებადი ფასადები და საიზოლაციო მასალები კომერციული და საცხოვრებელი მშენებლობისთვის.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20building%20facade%20cladding%20systems%20display%20showroom%20exterior%20panels%20elegant%20architecture%20warm%20lighting%20professional%20photography&width=600&height=800&seq=phoenix-cat-2&orientation=portrait',
    count: '180+',
    icon: 'ri-building-line',
  },
  {
    id: 6,
    title: 'სამშენებლო ქიმია',
    subtitle: 'Ardex, Tecnopol',
    description: 'Ardex და Tecnopol-ის წებოები, შემმავსებლები, ჰიდროიზოლაცია და სამშენებლო ქიმიური პროდუქტები საერთაშორისო გამოყენებისთვის.',
    image: 'https://readdy.ai/api/search-image?query=Construction%20chemicals%20adhesives%20grout%20sealant%20products%20display%20showroom%20professional%20building%20materials%20warm%20lighting%20photography&width=600&height=800&seq=phoenix-cat-6&orientation=portrait',
    count: '450+',
    icon: 'ri-flask-line',
  },
];

export default function CategoriesGrid() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [activeId, setActiveId] = useState<number | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-up');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const els = sectionRef.current?.querySelectorAll('.reveal');
    els?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="bg-phoenix-cream py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div className="reveal opacity-0 text-center mb-16 md:mb-20">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-px bg-phoenix-red"></div>
            <span className="text-phoenix-red text-xs font-semibold tracking-[0.3em] uppercase">კატეგორიები</span>
            <div className="w-8 h-px bg-phoenix-red"></div>
          </div>
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-phoenix-dark mb-4">
            პროდუქტების ასორტიმენტი
          </h2>
          <p className="text-phoenix-gray text-base md:text-lg max-w-2xl mx-auto">
            ყველა კატეგორია ერთ სივრცეში — აირჩიეთ თქვენი პროექტისთვის შესაფერისი მასალები
          </p>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {categories.map((cat, index) => (
            <div
              key={cat.id}
              className={`reveal opacity-0 group relative overflow-hidden rounded-sm bg-white cursor-pointer transition-all duration-500 ${
                activeId === cat.id ? 'ring-2 ring-phoenix-red' : ''
              }`}
              style={{ animationDelay: `${index * 0.1}s` }}
              onMouseEnter={() => setActiveId(cat.id)}
              onMouseLeave={() => setActiveId(null)}
            >
              {/* Image */}
              <div className="relative h-64 md:h-72 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>

                {/* Count Badge */}
                <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm rounded-full px-3 py-1.5 text-xs font-semibold text-phoenix-dark">
                  {cat.count} პროდუქტი
                </div>

                {/* Icon */}
                <div className="absolute bottom-4 left-4 w-10 h-10 rounded-sm bg-phoenix-red flex items-center justify-center">
                  <i className={`${cat.icon} text-white text-lg`}></i>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="font-serif text-xl font-bold text-phoenix-dark mb-1 group-hover:text-phoenix-red transition-colors duration-300">
                  {cat.title}
                </h3>
                <p className="text-xs text-phoenix-red font-medium mb-3">{cat.subtitle}</p>
                <p className="text-sm text-phoenix-gray leading-relaxed mb-4">{cat.description}</p>

                <div className="flex items-center gap-2 text-sm font-semibold text-phoenix-dark group-hover:text-phoenix-red transition-colors duration-300">
                  <span>დეტალურად</span>
                  <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}